import React from 'react';
import './FundNoteTip.scss';
import { COLLEGE_FUND_NOTE_PHONE_NUMBERS } from '../../../../settings/settings';
import If from '../../../Shared/If/If';
import Phone from '../../../Shared/Phone/Phone';
import {
  calculateAndFormatUnixDates,
  futureDate,
} from '../../../../utils/dates/date-utility';
import { formatShares } from '../../../../utils/utils';
import words from '../../../../utils/words';
import { isCollegeDistribute } from '../../../../utils/transactions-util';

const productTypePhoneMap = {
  ...COLLEGE_FUND_NOTE_PHONE_NUMBERS,
  defaultNumber: '800-225-5132',
};

const UncollectedFundNoteTip = ({
  fund,
  sellUncollectedShares: { hasError },
  uncollectedSharesLookup,
}) => (
  <div className="exclude">
    <If test={fund.hasUncollectedSharesDate}>
      You currently own{' '}
      {formatShares(
        fund.uncollectedSharesQuantity,
        'uncollected',
        words.shares
      )}{' '}
      of this {words.fund}.
      {uncollectedSharesLookup[fund.agreementID]?.length > 1
        ? ` Uncollected ${words.shares} will begin to be `
        : ` All ${words.shares} will be `}
      available to {words.sell} online on{' '}
      {calculateAndFormatUnixDates(futureDate(fund.settlementDate, 7))}.
    </If>
    <If test={hasError || !fund.hasUncollectedSharesDate}>
      You currently own uncollected {words.shares} of this {words.fund}.{' '}
      {words.Shares} will be available to {words.sell} 7 days after purchase.
    </If>

    <div className="fund-note-tip-space exclude">
      {isCollegeDistribute() ? (
        <span className="exclude">
          Call{' '}
          <Phone
            phoneNumber={
              productTypePhoneMap[fund.productType] ||
              productTypePhoneMap.defaultNumber
            }
          />{' '}
          to discuss options.
        </span>
      ) : (
        <span className="exclude">
          To place a trade before the above date, please{' '}
          <a
            href="https://www.troweprice.com/personal-investing/help/contact/index.html"
            target="_blank"
            rel="noreferrer"
            className="exclude"
          >
            contact us
          </a>{' '}
          to speak with an associate.
        </span>
      )}
    </div>
  </div>
);

export default UncollectedFundNoteTip;
